var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScientist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 176,
    viewBox: "0 0 476 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393.016 78.5274L391.883 75.5216V72.6411C391.883 71.7645 391.757 71.013 391.379 70.1363L385.46 53.9805L380.423 55.7338L386.342 71.8897C386.594 72.6411 387.097 73.3926 387.601 74.0188L389.49 76.2731L390.623 79.2788C390.875 79.905 391.631 80.2807 392.26 80.0302C392.89 79.905 393.268 79.1536 393.016 78.5274Z",
    fill: "#7FBFE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.083 52.0997L379.543 54.1035C379.165 54.2288 379.039 54.6045 379.165 54.9802L379.291 55.4812C379.417 55.8569 379.795 55.9821 380.172 55.8569L385.713 53.8531C386.091 53.7278 386.217 53.3521 386.091 52.9764L385.965 52.4754C385.965 52.225 385.461 51.9745 385.083 52.0997Z",
    fill: "#2F5968"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.794 44.837L378.913 45.2128C378.157 45.4632 377.905 46.2147 378.157 46.9661L380.675 53.8543L384.075 52.6019L381.557 45.7137C381.305 44.9623 380.55 44.5866 379.794 44.837Z",
    fill: "#2F5968"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.016 78.5274L391.883 75.5216V72.6411C391.883 71.7645 391.757 71.013 391.379 70.1363L385.46 53.9805L380.423 55.7338L386.342 71.8897C386.594 72.6411 387.097 73.3926 387.601 74.0188L389.49 76.2731L390.623 79.2788C390.875 79.905 391.631 80.2807 392.26 80.0302C392.89 79.905 393.268 79.1536 393.016 78.5274Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.01 79.2758C391.758 79.4011 391.506 79.2759 391.506 79.0254L390.372 75.8944L388.484 73.5148C387.98 72.8886 387.602 72.2624 387.35 71.6362L385.335 66.0005L389.113 65.75L390.876 70.3839C391.128 71.1353 391.254 71.7615 391.254 72.5129V75.5187L392.387 78.6497C392.261 79.0254 392.135 79.2758 392.01 79.2758Z",
    fill: "#ED36F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M383.829 51.6259L380.395 52.8633L380.738 53.8053L384.172 52.5679L383.829 51.6259Z",
    fill: "#14363F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.874 104.7C237.874 104.7 228.43 156.549 236.489 159.304C244.549 162.185 124.793 159.304 124.793 159.304L165.971 70.5098L237.874 104.7Z",
    fill: "#BFDEEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.784 105.329H368.718V104.076H360.784V105.329Z",
    fill: "url(#paint1_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M368.715 104.076H360.656L360.53 138.392C360.53 140.02 361.789 141.272 363.426 141.272H365.693C367.33 141.272 368.589 140.02 368.589 138.392L368.715 104.076Z",
    fill: "url(#paint2_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M368.715 104.076H360.656L360.53 138.392C360.53 140.02 361.789 141.272 363.426 141.272H365.693C367.33 141.272 368.589 140.02 368.589 138.392L368.715 104.076Z",
    fill: "url(#paint3_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M368.715 104.076H360.656L360.53 138.392C360.53 140.02 361.789 141.272 363.426 141.272H365.693C367.33 141.272 368.589 140.02 368.589 138.392L368.715 104.076Z",
    fill: "url(#paint4_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M364.562 140.019C363.051 140.019 361.791 138.767 361.791 137.264L361.917 111.465H367.458L367.332 137.264C367.332 138.767 366.073 140.019 364.562 140.019Z",
    fill: "#5EE52C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M368.841 101.695H360.655C360.152 101.695 359.648 102.071 359.648 102.697V103.449C359.648 103.95 360.026 104.451 360.655 104.451H368.841C369.344 104.451 369.848 104.075 369.848 103.449V102.697C369.848 102.071 369.47 101.695 368.841 101.695Z",
    fill: "#7FBFE2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M367.078 115.097H366.7C366.448 115.097 366.322 114.846 366.322 114.596V105.704C366.322 105.453 366.574 105.328 366.826 105.328H367.204C367.456 105.328 367.582 105.579 367.582 105.829V114.721C367.456 114.972 367.33 115.097 367.078 115.097Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M374.633 105.327H382.693V104.074H374.633V105.327Z",
    fill: "url(#paint5_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M382.694 104.074H374.635L374.509 138.39C374.509 140.018 375.768 141.27 377.405 141.27H379.672C381.309 141.27 382.568 140.018 382.568 138.39L382.694 104.074Z",
    fill: "url(#paint6_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M382.694 104.074H374.635L374.509 138.39C374.509 140.018 375.768 141.27 377.405 141.27H379.672C381.309 141.27 382.568 140.018 382.568 138.39L382.694 104.074Z",
    fill: "url(#paint7_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M382.694 104.074H374.635L374.509 138.39C374.509 140.018 375.768 141.27 377.405 141.27H379.672C381.309 141.27 382.568 140.018 382.568 138.39L382.694 104.074Z",
    fill: "url(#paint8_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M378.538 140.017C377.027 140.017 375.768 138.765 375.768 137.262L375.894 111.463H381.434L381.308 137.262C381.308 138.765 380.049 140.017 378.538 140.017Z",
    fill: "#5EE52C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M382.817 101.695H374.632C374.128 101.695 373.625 102.071 373.625 102.697V103.449C373.625 103.95 374.003 104.451 374.632 104.451H382.817C383.321 104.451 383.825 104.075 383.825 103.449V102.697C383.825 102.071 383.321 101.695 382.817 101.695Z",
    fill: "#7FBFE2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M380.931 115.095H380.553C380.301 115.095 380.175 114.844 380.175 114.594V105.702C380.175 105.451 380.427 105.326 380.679 105.326H381.057C381.309 105.326 381.435 105.577 381.435 105.827V114.719C381.435 114.97 381.183 115.095 380.931 115.095Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M388.611 105.327H396.545V104.074H388.611V105.327Z",
    fill: "url(#paint9_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M396.545 104.074H388.486L388.36 138.39C388.36 140.018 389.619 141.27 391.256 141.27H393.523C395.16 141.27 396.419 140.018 396.419 138.39L396.545 104.074Z",
    fill: "url(#paint10_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M396.545 104.074H388.486L388.36 138.39C388.36 140.018 389.619 141.27 391.256 141.27H393.523C395.16 141.27 396.419 140.018 396.419 138.39L396.545 104.074Z",
    fill: "url(#paint11_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M396.545 104.074H388.486L388.36 138.39C388.36 140.018 389.619 141.27 391.256 141.27H393.523C395.16 141.27 396.419 140.018 396.419 138.39L396.545 104.074Z",
    fill: "url(#paint12_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M392.387 140.019C390.876 140.019 389.616 138.767 389.616 137.264L389.742 111.465H395.283L395.157 137.264C395.157 138.767 393.898 140.019 392.387 140.019Z",
    fill: "#5EE52C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M396.668 101.695H388.483C387.979 101.695 387.476 102.071 387.476 102.697V103.449C387.476 103.95 387.853 104.451 388.483 104.451H396.668C397.172 104.451 397.676 104.075 397.676 103.449V102.697C397.676 102.071 397.298 101.695 396.668 101.695Z",
    fill: "#7FBFE2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M394.903 115.097H394.525C394.273 115.097 394.147 114.846 394.147 114.596V105.704C394.147 105.453 394.399 105.328 394.651 105.328H395.029C395.281 105.328 395.407 105.579 395.407 105.829V114.721C395.281 114.972 395.029 115.097 394.903 115.097Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M471.845 109.084H373.497L348.689 134.883V153.168H463.66L471.845 143.274V109.084Z",
    fill: "url(#paint13_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M469.703 75.7715H415.555L398.681 109.085L457.237 109.336L469.703 75.7715Z",
    fill: "url(#paint14_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M439.48 61.9961H429.532L412.28 99.8184H413.288C418.703 99.8184 423.74 96.6874 426.006 91.6778L439.48 61.9961Z",
    fill: "#6393A8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M471.843 61.9961H461.769L455.473 75.7724L465.547 75.6472L471.843 61.9961Z",
    fill: "url(#paint15_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M467.814 61.9961H435.702V70.6376H467.814V61.9961Z",
    fill: "#6393A8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M452.704 136.137H348.689V134.884L349.949 133.632H450.941L457.867 115.723L460.134 116.725L452.704 136.137Z",
    fill: "url(#paint16_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M362.546 50.8467L348.82 56.9834L343.531 50.7215L348.316 45.2109",
    fill: "url(#paint17_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M368.59 29.9313C368.59 29.9313 376.145 28.8042 381.183 26.6751C386.22 24.546 390.501 21.916 390.501 21.916C390.501 21.916 391.634 28.8042 380.049 32.4361C368.464 36.0681 368.59 29.9313 368.59 29.9313Z",
    fill: "url(#paint18_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M346.175 46.0876C346.175 46.0876 351.968 43.3323 356.249 38.0723C360.531 32.8122 361.664 29.1803 369.849 29.8065C378.035 30.5579 384.709 30.8084 384.709 30.8084L386.975 35.9432C386.975 35.9432 388.109 35.9432 388.235 38.3228C388.36 40.7023 386.346 43.8333 385.464 46.3381C384.583 48.8429 382.82 53.2262 381.812 48.8429C380.805 44.3342 382.694 41.4537 382.694 41.4537L376.02 39.4499C376.02 39.4499 370.605 41.7042 370.983 43.3323C371.235 44.71 375.768 44.3342 378.538 46.5886C379.672 47.5905 381.56 52.3496 378.16 51.2224C374.383 49.8448 373.375 48.2167 368.968 50.2205C368.968 50.2205 364.812 52.9758 358.894 50.7215",
    fill: "#DF876F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M257.015 25.0471C260.918 32.8119 245.303 47.3397 243.289 59.1122C241.274 70.7595 251.096 93.1773 251.096 93.1773C251.096 93.1773 221.377 82.532 207.652 82.532C193.926 82.532 160.807 114.593 160.807 114.593C160.807 114.593 174.407 93.0521 180.326 66.0004C187.377 33.9391 193.548 2.87974 225.281 2.87974C262.555 2.7545 252.859 16.7813 257.015 25.0471Z",
    fill: "#750909"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M239.008 29.8069L225.534 18.4102L209.919 44.2095L210.297 57.9858L218.608 61.3673L222.26 52.9762L239.008 29.8069Z",
    fill: "url(#paint19_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M246.059 8.76631C246.059 8.76631 261.799 15.2788 253.362 30.9337C244.925 46.5886 235.229 48.5924 232.333 47.2148C227.044 44.71 223.392 31.9356 222.636 26.2998C221.503 19.0359 226.54 1.00147 246.059 8.76631Z",
    fill: "#DF876F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M238.756 34.9425C241.747 34.9425 244.171 32.5314 244.171 29.5572C244.171 26.583 241.747 24.1719 238.756 24.1719C235.766 24.1719 233.341 26.583 233.341 29.5572C233.341 32.5314 235.766 34.9425 238.756 34.9425Z",
    stroke: "#84BFD8",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M252.103 40.8282C254.954 40.8282 257.266 38.5293 257.266 35.6934C257.266 32.8575 254.954 30.5586 252.103 30.5586C249.251 30.5586 246.94 32.8575 246.94 35.6934C246.94 38.5293 249.251 40.8282 252.103 40.8282Z",
    stroke: "#84BFD8",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M265.58 27.1784C265.58 27.1784 254.876 32.0628 247.95 20.4155C241.024 8.76825 240.772 6.88967 240.772 6.88967C240.772 6.88967 252.106 2.882 257.646 9.77017C260.794 13.5273 256.765 27.1784 265.58 27.1784Z",
    fill: "#750909"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 17.4083C222.637 17.4083 240.266 15.0287 244.17 12.3987C248.074 9.64343 250.97 0 239.259 0C227.548 0 215.963 8.76676 209.54 18.4102C203.118 28.0536 218.733 18.4102 222.637 17.4083Z",
    fill: "#750909"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M222.636 24.2961C224.792 24.2961 226.54 22.5579 226.54 20.4137C226.54 18.2695 224.792 16.5312 222.636 16.5312C220.48 16.5312 218.732 18.2695 218.732 20.4137C218.732 22.5579 220.48 24.2961 222.636 24.2961Z",
    fill: "url(#paint20_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M240.77 27.1758L235.355 29.1796L235.607 30.0563L241.148 28.0525L240.77 27.1758Z",
    fill: "url(#paint21_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M178.185 105.577C176.8 130.375 297.437 138.641 297.437 138.641V152.417C297.437 152.417 297.437 152.417 207.651 152.417C117.866 152.417 115.851 102.822 133.859 76.6472C143.933 61.9942 166.474 53.4779 184.355 48.7188C184.355 48.7188 185.237 46.8402 185.614 46.715C199.466 43.083 210.17 43.584 210.17 43.584L207.148 54.9807L220.118 60.2408L222.385 53.1022C222.385 53.1022 252.985 91.0497 272.629 86.5411C292.274 82.0325 347.429 44.0849 347.429 44.0849L354.229 55.7322C354.229 55.7322 316.703 105.202 291.77 116.724C265.2 128.997 237.118 119.855 237.118 119.855",
    fill: "#BFDEEF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M246.314 49.8477C245.558 51.601 244.803 53.2291 244.173 54.9825C243.543 56.7358 243.04 58.4892 242.914 60.2425C242.662 61.9959 242.788 63.8745 242.914 65.7531C243.04 67.6317 243.292 69.385 243.543 71.2636C243.04 69.5102 242.536 67.6317 242.284 65.7531C242.032 63.8745 241.906 61.9959 242.032 60.1173C242.158 58.2387 242.788 56.3601 243.543 54.6068C244.299 52.9786 245.306 51.3505 246.314 49.8477Z",
    fill: "#750909"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M191.787 20.4158C192.669 18.412 193.802 16.5334 195.061 14.7801C196.32 13.0267 197.706 11.2734 199.217 9.7705C200.728 8.26763 202.491 6.89 204.38 5.76284C206.269 4.63569 208.283 3.75901 210.298 3.13281C208.409 4.13473 206.52 5.13665 204.757 6.38904C202.995 7.64143 201.357 8.89382 199.846 10.3967C198.335 11.8996 196.95 13.5277 195.565 15.1558C194.18 16.7839 193.046 18.5373 191.787 20.4158Z",
    fill: "#750909"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 142.022C306.375 142.022 314.435 143.4 320.605 143.024C326.775 142.649 338.738 148.66 338.738 148.66C339.872 149.286 342.264 153.169 339.116 152.668C335.716 152.167 325.012 151.165 316.072 152.543C314.561 152.793 312.42 150.539 310.153 150.539C307.886 150.539 297.435 151.29 297.435 151.29V141.521L306.375 142.022Z",
    fill: "url(#paint22_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 142.023C306.375 142.023 312.041 141.898 317.33 139.268C322.619 136.638 323.878 133.632 330.175 137.139C336.471 140.645 341.634 143.275 341.634 143.275C341.634 143.275 354.604 149.412 360.019 148.786C360.019 148.786 360.019 152.293 353.471 152.293C353.471 152.293 344.908 151.416 339.997 149.788C335.086 148.16 329.419 145.154 325.515 145.53C321.612 145.78 318.715 147.659 309.523 147.033",
    fill: "#DF876F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 142.022C306.375 142.022 314.435 143.4 320.605 143.024C326.775 142.649 338.738 148.66 338.738 148.66C339.872 149.286 342.264 153.169 339.116 152.668C335.716 152.167 325.012 151.165 316.072 152.543C314.561 152.793 312.42 150.539 310.153 150.539C307.886 150.539 297.435 151.29 297.435 151.29V141.521L306.375 142.022Z",
    fill: "url(#paint23_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M222.256 52.9752C222.256 52.9752 219.36 58.611 216.841 57.6091C213.19 56.2315 210.041 43.457 210.041 43.457C209.79 44.2085 180.323 65.8749 206.516 107.705C206.516 107.705 229.056 58.611 222.256 52.9752Z",
    fill: "#FFF53E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M394.149 94.5563C394.149 93.6796 392.385 91.6758 392.385 91.6758C392.385 91.6758 390.748 93.8048 390.748 94.8068C390.748 95.6834 391.63 96.4349 392.511 96.4349C393.519 96.3096 394.275 95.433 394.149 94.5563Z",
    fill: "#ED36F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M178.188 105.576C177.558 117.599 205.262 125.614 234.099 130.875C234.099 130.875 235.61 115.595 236.239 114.593C236.869 113.591 178.188 105.576 178.188 105.576Z",
    fill: "url(#paint24_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M207.653 152.417C171.134 152.417 149.223 144.151 137.134 132.754L128.067 152.417H207.653Z",
    fill: "url(#paint25_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M167.481 53.979C173.274 51.85 178.94 50.0966 184.355 48.5938C184.355 48.5938 175.163 60.4915 181.333 85.9151C181.333 86.1656 162.948 94.3061 162.948 94.3061L167.481 53.979Z",
    fill: "url(#paint26_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M252.103 80.6561C247.066 77.5251 242.155 73.3922 237.873 69.5098C237.873 69.5098 237.873 94.4324 219.866 111.465L241.022 118.478L252.103 80.6561Z",
    fill: "url(#paint27_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M248.955 50.2227C248.2 51.976 247.444 53.6041 246.94 55.3575C246.311 57.1108 245.807 58.8642 245.681 60.6175C245.429 62.3709 245.555 64.2495 245.681 66.0028C245.807 67.8814 246.059 69.6348 246.185 71.5133C245.681 69.76 245.177 67.8814 244.926 66.1281C244.674 64.2495 244.548 62.3709 244.674 60.4923C244.8 58.6137 245.429 56.7351 246.185 55.107C246.94 53.3536 247.948 51.7255 248.955 50.2227Z",
    fill: "#750909"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M393.016 78.5274L391.883 75.5216V72.6411C391.883 71.7645 391.757 71.013 391.379 70.1363L385.46 53.9805L380.423 55.7338L386.342 71.8897C386.594 72.6411 387.097 73.3926 387.601 74.0188L389.49 76.2731L390.623 79.2788C390.875 79.905 391.631 80.2807 392.26 80.0302C392.89 79.905 393.268 79.1536 393.016 78.5274Z",
    fill: "#7FBFE2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M385.083 52.0997L379.543 54.1035C379.165 54.2288 379.039 54.6045 379.165 54.9802L379.291 55.4812C379.417 55.8569 379.795 55.9821 380.172 55.8569L385.713 53.8531C386.091 53.7278 386.217 53.3521 386.091 52.9764L385.965 52.4754C385.965 52.225 385.461 51.9745 385.083 52.0997Z",
    fill: "#2F5968"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M379.794 44.837L378.913 45.2128C378.157 45.4632 377.905 46.2147 378.157 46.9661L380.675 53.8543L384.075 52.6019L381.557 45.7137C381.305 44.9623 380.55 44.5866 379.794 44.837Z",
    fill: "#2F5968"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M393.016 78.5274L391.883 75.5216V72.6411C391.883 71.7645 391.757 71.013 391.379 70.1363L385.46 53.9805L380.423 55.7338L386.342 71.8897C386.594 72.6411 387.097 73.3926 387.601 74.0188L389.49 76.2731L390.623 79.2788C390.875 79.905 391.631 80.2807 392.26 80.0302C392.89 79.905 393.268 79.1536 393.016 78.5274Z",
    fill: "url(#paint28_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M392.01 79.2758C391.758 79.4011 391.506 79.2759 391.506 79.0254L390.372 75.8944L388.484 73.5148C387.98 72.8886 387.602 72.2624 387.35 71.6362L385.335 66.0005L389.113 65.75L390.876 70.3839C391.128 71.1353 391.254 71.7615 391.254 72.5129V75.5187L392.387 78.6497C392.261 79.0254 392.135 79.2758 392.01 79.2758Z",
    fill: "#1E3799"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M383.829 51.6259L380.395 52.8633L380.738 53.8053L384.172 52.5679L383.829 51.6259Z",
    fill: "#14363F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M237.874 104.7C237.874 104.7 237.83 171.573 245.889 174.328C253.949 177.209 124.793 159.304 124.793 159.304L165.971 70.5098L237.874 104.7Z",
    fill: "#BFDEEF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M360.784 105.329H368.718V104.076H360.784V105.329Z",
    fill: "url(#paint29_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M368.715 104.076H360.656L360.53 138.392C360.53 140.02 361.789 141.272 363.426 141.272H365.693C367.33 141.272 368.589 140.02 368.589 138.392L368.715 104.076Z",
    fill: "url(#paint30_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M368.715 104.076H360.656L360.53 138.392C360.53 140.02 361.789 141.272 363.426 141.272H365.693C367.33 141.272 368.589 140.02 368.589 138.392L368.715 104.076Z",
    fill: "url(#paint31_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M368.715 104.076H360.656L360.53 138.392C360.53 140.02 361.789 141.272 363.426 141.272H365.693C367.33 141.272 368.589 140.02 368.589 138.392L368.715 104.076Z",
    fill: "url(#paint32_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M364.562 140.019C363.051 140.019 361.791 138.767 361.791 137.264L361.917 111.465H367.458L367.332 137.264C367.332 138.767 366.073 140.019 364.562 140.019Z",
    fill: "#218C74"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M368.841 101.695H360.655C360.152 101.695 359.648 102.071 359.648 102.697V103.449C359.648 103.95 360.026 104.451 360.655 104.451H368.841C369.344 104.451 369.848 104.075 369.848 103.449V102.697C369.848 102.071 369.47 101.695 368.841 101.695Z",
    fill: "#7FBFE2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M367.078 115.097H366.7C366.448 115.097 366.322 114.846 366.322 114.596V105.704C366.322 105.453 366.574 105.328 366.826 105.328H367.204C367.456 105.328 367.582 105.579 367.582 105.829V114.721C367.456 114.972 367.33 115.097 367.078 115.097Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M374.633 105.327H382.693V104.074H374.633V105.327Z",
    fill: "url(#paint33_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M382.694 104.074H374.635L374.509 138.39C374.509 140.018 375.768 141.27 377.405 141.27H379.672C381.309 141.27 382.568 140.018 382.568 138.39L382.694 104.074Z",
    fill: "url(#paint34_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M382.694 104.074H374.635L374.509 138.39C374.509 140.018 375.768 141.27 377.405 141.27H379.672C381.309 141.27 382.568 140.018 382.568 138.39L382.694 104.074Z",
    fill: "url(#paint35_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M382.694 104.074H374.635L374.509 138.39C374.509 140.018 375.768 141.27 377.405 141.27H379.672C381.309 141.27 382.568 140.018 382.568 138.39L382.694 104.074Z",
    fill: "url(#paint36_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M378.538 140.017C377.027 140.017 375.768 138.765 375.768 137.262L375.894 111.463H381.434L381.308 137.262C381.308 138.765 380.049 140.017 378.538 140.017Z",
    fill: "#5EE52C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M382.817 101.695H374.632C374.128 101.695 373.625 102.071 373.625 102.697V103.449C373.625 103.95 374.003 104.451 374.632 104.451H382.817C383.321 104.451 383.825 104.075 383.825 103.449V102.697C383.825 102.071 383.321 101.695 382.817 101.695Z",
    fill: "#7FBFE2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M380.931 115.095H380.553C380.301 115.095 380.175 114.844 380.175 114.594V105.702C380.175 105.451 380.427 105.326 380.679 105.326H381.057C381.309 105.326 381.435 105.577 381.435 105.827V114.719C381.435 114.97 381.183 115.095 380.931 115.095Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M388.611 105.327H396.545V104.074H388.611V105.327Z",
    fill: "url(#paint37_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M396.545 104.074H388.486L388.36 138.39C388.36 140.018 389.619 141.27 391.256 141.27H393.523C395.16 141.27 396.419 140.018 396.419 138.39L396.545 104.074Z",
    fill: "url(#paint38_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M396.545 104.074H388.486L388.36 138.39C388.36 140.018 389.619 141.27 391.256 141.27H393.523C395.16 141.27 396.419 140.018 396.419 138.39L396.545 104.074Z",
    fill: "url(#paint39_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M396.545 104.074H388.486L388.36 138.39C388.36 140.018 389.619 141.27 391.256 141.27H393.523C395.16 141.27 396.419 140.018 396.419 138.39L396.545 104.074Z",
    fill: "url(#paint40_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M392.387 140.019C390.876 140.019 389.616 138.767 389.616 137.264L389.742 111.465H395.283L395.157 137.264C395.157 138.767 393.898 140.019 392.387 140.019Z",
    fill: "#5EE52C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M396.668 101.695H388.483C387.979 101.695 387.476 102.071 387.476 102.697V103.449C387.476 103.95 387.853 104.451 388.483 104.451H396.668C397.172 104.451 397.676 104.075 397.676 103.449V102.697C397.676 102.071 397.298 101.695 396.668 101.695Z",
    fill: "#7FBFE2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M394.903 115.097H394.525C394.273 115.097 394.147 114.846 394.147 114.596V105.704C394.147 105.453 394.399 105.328 394.651 105.328H395.029C395.281 105.328 395.407 105.579 395.407 105.829V114.721C395.281 114.972 395.029 115.097 394.903 115.097Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M471.845 109.084H373.497L348.689 134.883V153.168H463.66L471.845 143.274V109.084Z",
    fill: "url(#paint41_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M469.703 75.7715H415.555L398.681 109.085L457.237 109.336L469.703 75.7715Z",
    fill: "url(#paint42_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M439.48 61.9961H429.532L412.28 99.8184H413.288C418.703 99.8184 423.74 96.6874 426.006 91.6778L439.48 61.9961Z",
    fill: "#6393A8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M471.843 61.9961H461.769L455.473 75.7724L465.547 75.6472L471.843 61.9961Z",
    fill: "url(#paint43_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M467.814 61.9961H435.702V70.6376H467.814V61.9961Z",
    fill: "#6393A8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M452.704 136.137H348.689V134.884L349.949 133.632H450.941L457.867 115.723L460.134 116.725L452.704 136.137Z",
    fill: "url(#paint44_linear)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M360.401 51.8508L346.675 57.9876L341.386 51.6004L346.171 46.0898",
    fill: "url(#paint45_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M368.586 29.9333C368.586 29.9333 376.142 28.8061 381.179 26.6771C386.216 24.548 390.498 21.918 390.498 21.918C390.498 21.918 391.631 28.8061 380.046 32.4381C368.461 36.07 368.586 29.9333 368.586 29.9333Z",
    fill: "url(#paint46_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M346.171 46.0896C346.171 46.0896 351.963 43.3343 356.245 38.0742C360.526 32.8142 361.66 29.1822 369.845 29.8084C378.03 30.5599 384.704 30.8103 384.704 30.8103L386.971 35.9452C386.971 35.9452 388.104 35.9452 388.23 38.3247C388.356 40.7043 386.341 43.8352 385.46 46.34C384.578 48.8448 382.815 53.2282 381.808 48.8448C380.801 44.3362 382.689 41.4557 382.689 41.4557L376.015 39.4519C376.015 39.4519 370.601 41.7062 370.978 43.3343C371.23 44.7119 375.763 44.3362 378.534 46.5905C379.667 47.5924 381.556 52.3515 378.156 51.2244C374.378 49.8467 371.734 49.0953 367.326 51.2244C367.326 51.2244 363.171 53.9796 357.252 51.7253",
    fill: "#EBA896"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M257.015 25.0471C260.918 32.8119 245.303 47.3397 243.289 59.1122C241.274 70.7595 251.096 93.1773 251.096 93.1773C251.096 93.1773 221.377 82.532 207.652 82.532C193.926 82.532 160.807 114.593 160.807 114.593C160.807 114.593 174.407 93.0521 180.326 66.0004C187.377 33.9391 193.548 2.87974 225.281 2.87974C262.555 2.7545 252.859 16.7813 257.015 25.0471Z",
    fill: "#B33939"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M239.008 29.8069L225.534 18.4102L209.919 44.2095L210.297 57.9858L218.608 61.3673L222.26 52.9762L239.008 29.8069Z",
    fill: "url(#paint47_linear)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M246.059 8.76631C246.059 8.76631 261.799 15.2788 253.362 30.9337C244.925 46.5886 235.229 48.5924 232.333 47.2148C227.044 44.71 223.392 31.9356 222.636 26.2998C221.503 19.0359 226.54 1.00147 246.059 8.76631Z",
    fill: "#EBA896"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M238.494 35.005C241.485 35.005 243.909 32.5939 243.909 29.6197C243.909 26.6455 241.485 24.2344 238.494 24.2344C235.504 24.2344 233.08 26.6455 233.08 29.6197C233.08 32.5939 235.504 35.005 238.494 35.005Z",
    stroke: "#84BFD8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M251.841 40.8907C254.693 40.8907 257.004 38.5918 257.004 35.7559C257.004 32.92 254.693 30.6211 251.841 30.6211C248.99 30.6211 246.678 32.92 246.678 35.7559C246.678 38.5918 248.99 40.8907 251.841 40.8907Z",
    stroke: "#84BFD8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M265.58 27.1784C265.58 27.1784 254.876 32.0628 247.95 20.4155C241.024 8.76825 240.772 6.88967 240.772 6.88967C240.772 6.88967 252.106 2.882 257.646 9.77017C260.794 13.5273 256.765 27.1784 265.58 27.1784Z",
    fill: "#B33939"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M222.637 17.4083C222.637 17.4083 240.266 15.0287 244.17 12.3987C248.074 9.64343 250.97 0 239.259 0C227.548 0 215.963 8.76676 209.54 18.4102C203.118 28.0536 218.733 18.4102 222.637 17.4083Z",
    fill: "#B33939"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M222.636 24.2961C224.792 24.2961 226.54 22.5579 226.54 20.4137C226.54 18.2695 224.792 16.5312 222.636 16.5312C220.48 16.5312 218.732 18.2695 218.732 20.4137C218.732 22.5579 220.48 24.2961 222.636 24.2961Z",
    fill: "url(#paint48_linear)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M240.77 27.1758L235.355 29.1796L235.607 30.0563L241.148 28.0525L240.77 27.1758Z",
    fill: "url(#paint49_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M178.32 105.691C176.934 130.488 297.571 138.754 297.571 138.754V152.531C297.571 152.531 297.571 152.531 207.786 152.531C118.001 152.531 115.986 102.936 133.994 76.7608C144.068 62.1078 166.011 53.7856 183.892 49.0265C183.892 49.0265 185.471 47.0227 185.849 46.8975C199.701 43.2655 210.179 43.6976 210.179 43.6976L207.157 55.0944L220.127 60.3545L222.394 53.2158C222.394 53.2158 252.994 91.1633 272.638 86.6547C292.283 82.1461 347.438 44.1986 347.438 44.1986L354.238 55.8458C354.238 55.8458 316.712 105.315 291.779 116.837C265.208 129.111 237.127 119.968 237.127 119.968",
    fill: "#BFDEEF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M191.787 20.4158C192.669 18.412 193.802 16.5334 195.061 14.7801C196.32 13.0267 197.706 11.2734 199.217 9.7705C200.728 8.26763 202.491 6.89 204.38 5.76284C206.269 4.63569 208.283 3.75901 210.298 3.13281C208.409 4.13473 206.52 5.13665 204.757 6.38904C202.995 7.64143 201.357 8.89382 199.846 10.3967C198.335 11.8996 196.95 13.5277 195.565 15.1558C194.18 16.7839 193.046 18.5373 191.787 20.4158Z",
    fill: "#B33939"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 142.022C306.375 142.022 314.435 143.4 320.605 143.024C326.775 142.649 338.738 148.66 338.738 148.66C339.872 149.286 342.264 153.169 339.116 152.668C335.716 152.167 325.012 151.165 316.072 152.543C314.561 152.793 312.42 150.539 310.153 150.539C307.886 150.539 297.435 151.29 297.435 151.29V141.521L306.375 142.022Z",
    fill: "url(#paint50_linear)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 142.023C306.375 142.023 312.041 141.898 317.33 139.268C322.619 136.638 323.878 133.632 330.175 137.139C336.471 140.645 341.634 143.275 341.634 143.275C341.634 143.275 354.604 149.412 360.019 148.786C360.019 148.786 360.019 152.293 353.471 152.293C353.471 152.293 344.908 151.416 339.997 149.788C335.086 148.16 329.419 145.154 325.515 145.53C321.612 145.78 318.715 147.659 309.523 147.033",
    fill: "#EBA896"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M306.375 142.022C306.375 142.022 314.435 143.4 320.605 143.024C326.775 142.649 338.738 148.66 338.738 148.66C339.872 149.286 342.264 153.169 339.116 152.668C335.716 152.167 325.012 151.165 316.072 152.543C314.561 152.793 312.42 150.539 310.153 150.539C307.886 150.539 297.435 151.29 297.435 151.29V141.521L306.375 142.022Z",
    fill: "url(#paint51_linear)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M222.256 52.9752C222.256 52.9752 219.36 58.611 216.841 57.6091C213.19 56.2315 210.041 43.457 210.041 43.457C209.79 44.2085 180.323 65.8749 206.516 107.705C206.516 107.705 229.056 58.611 222.256 52.9752Z",
    fill: "url(#paint52_linear)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M394.149 94.5563C394.149 93.6796 392.385 91.6758 392.385 91.6758C392.385 91.6758 390.748 93.8048 390.748 94.8068C390.748 95.6834 391.63 96.4349 392.511 96.4349C393.519 96.3096 394.275 95.433 394.149 94.5563Z",
    fill: "#1E3799"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M178.383 105.703C177.753 117.726 209.512 126.233 238.349 131.493C238.349 131.493 237.72 115.605 238.349 114.603C238.979 113.601 178.383 105.703 178.383 105.703Z",
    fill: "url(#paint53_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M207.653 152.417C171.134 152.417 149.223 144.151 137.134 132.754L128.067 152.417H207.653Z",
    fill: "url(#paint54_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6415 145.736L77.604 152.123L171.041 152.666L171.079 146.278L77.6415 145.736Z",
    fill: "#6393A8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M164.213 150.763L164.38 118.576L162.49 118.567L162.324 150.753L164.213 150.763Z",
    fill: "#6393A8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M120.513 103.575H128.572V102.322H120.513V103.575Z",
    fill: "url(#paint55_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M128.573 102.32H120.514L120.388 136.636C120.388 138.264 121.647 139.516 123.284 139.516H125.551C127.188 139.516 128.447 138.264 128.447 136.636L128.573 102.32Z",
    fill: "url(#paint56_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M128.573 102.32H120.514L120.388 136.636C120.388 138.264 121.647 139.516 123.284 139.516H125.551C127.188 139.516 128.447 138.264 128.447 136.636L128.573 102.32Z",
    fill: "url(#paint57_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M128.573 102.32H120.514L120.388 136.636C120.388 138.264 121.647 139.516 123.284 139.516H125.551C127.188 139.516 128.447 138.264 128.447 136.636L128.573 102.32Z",
    fill: "url(#paint58_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M124.417 138.266C122.906 138.266 121.647 137.013 121.647 135.51L121.773 109.711H127.314L127.188 135.51C127.188 137.013 125.928 138.266 124.417 138.266Z",
    fill: "#616198"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M128.696 99.9414H120.511C120.008 99.9414 119.504 100.317 119.504 100.943V101.695C119.504 102.196 119.882 102.697 120.511 102.697H128.696C129.2 102.697 129.704 102.321 129.704 101.695V100.943C129.704 100.317 129.2 99.9414 128.696 99.9414Z",
    fill: "#7FBFE2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M126.81 113.343H126.433C126.181 113.343 126.055 113.092 126.055 112.842V103.95C126.055 103.699 126.307 103.574 126.559 103.574H126.936C127.188 103.574 127.314 103.825 127.314 104.075V112.967C127.314 113.218 127.062 113.343 126.81 113.343Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M142.677 103.698H150.736V102.571L142.677 102.445V103.698Z",
    fill: "url(#paint59_linear)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M150.733 102.57H142.674L142.548 136.886C142.548 138.514 143.807 139.766 145.444 139.766H147.711C149.348 139.766 150.607 138.514 150.607 136.886L150.733 102.57Z",
    fill: "url(#paint60_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M150.733 102.57H142.674L142.548 136.886C142.548 138.514 143.807 139.766 145.444 139.766H147.711C149.348 139.766 150.607 138.514 150.607 136.886L150.733 102.57Z",
    fill: "url(#paint61_linear)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M150.733 102.57H142.674L142.548 136.886C142.548 138.514 143.807 139.766 145.444 139.766H147.711C149.348 139.766 150.607 138.514 150.607 136.886L150.733 102.57Z",
    fill: "url(#paint62_linear)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M146.578 138.389C145.067 138.389 143.808 137.136 143.808 135.633L143.934 109.834H149.474L149.348 135.633C149.348 137.136 148.089 138.389 146.578 138.389Z",
    fill: "#FFB142"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M150.859 100.064H142.673C142.17 100.064 141.666 100.44 141.666 101.066V101.818C141.666 102.319 142.044 102.82 142.673 102.82H150.859C151.362 102.82 151.866 102.444 151.866 101.818V101.066C151.866 100.565 151.362 100.064 150.859 100.064Z",
    fill: "#7FBFE2"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M148.969 113.591H148.591C148.339 113.591 148.213 113.34 148.213 113.09V104.198C148.213 103.948 148.465 103.822 148.717 103.822H149.095C149.347 103.822 149.473 104.073 149.473 104.323V113.215C149.473 113.34 149.221 113.591 148.969 113.591Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6903 117.305L77.6675 121.188L171.105 121.73L171.127 117.848L77.6903 117.305Z",
    fill: "#6393A8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M147.669 150.47L147.836 118.283L145.191 118.27L145.024 150.456L147.669 150.47Z",
    fill: "#6393A8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M167.481 53.979C173.274 51.85 178.94 50.0966 184.355 48.5938C184.355 48.5938 169.622 64.8749 181.333 85.9151C181.459 86.1656 162.948 94.3061 162.948 94.3061L167.481 53.979Z",
    fill: "url(#paint63_linear)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M252.103 80.6561C247.066 77.5251 242.155 73.3922 237.873 69.5098C237.873 69.5098 237.873 94.4324 219.866 111.465L241.022 118.478L252.103 80.6561Z",
    fill: "url(#paint64_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M248.955 50.2227C248.2 51.976 247.444 53.6041 246.94 55.3575C246.311 57.1108 245.807 58.8642 245.681 60.6175C245.429 62.3709 245.555 64.2495 245.681 66.0028C245.807 67.8814 246.059 69.6348 246.185 71.5133C245.681 69.76 245.177 67.8814 244.926 66.1281C244.674 64.2495 244.548 62.3709 244.674 60.4923C244.8 58.6137 245.429 56.7351 246.185 55.107C246.94 53.3536 247.948 51.7255 248.955 50.2227Z",
    fill: "#B33939"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M471.467 152.831L4.65926 150.451C2.14074 150.451 0 152.455 0 155.085V164.353L476 164.228V157.465C476 154.96 473.985 152.831 471.467 152.831Z",
    fill: "#84BFD8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M463.061 164.227H12.8169C10.6078 164.227 8.81689 166.017 8.81689 168.227V171.999C8.81689 174.208 10.6078 175.999 12.8169 175.999H463.061C465.27 175.999 467.061 174.208 467.061 171.999V168.227C467.061 166.017 465.27 164.227 463.061 164.227Z",
    fill: "#6393A8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M467.061 164.227H8.81689V170.113H467.061V164.227Z",
    fill: "#2F5968"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M471.467 152.831L4.65926 150.451C2.14074 150.451 0 152.455 0 155.085V164.353L476 164.228V157.465C476 154.96 473.985 152.831 471.467 152.831Z",
    fill: "#84BFD8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M467.061 164.227H8.81689V170.113H467.061V164.227Z",
    fill: "#2F5968"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 391.973,
    y1: 77.1552,
    x2: 383.612,
    y2: 57.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 364.772,
    y1: 103.55,
    x2: 364.763,
    y2: 105.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 364.478,
    y1: 158.165,
    x2: 364.756,
    y2: 104.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 359.912,
    y1: 122.652,
    x2: 363.524,
    y2: 122.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 359.912,
    y1: 122.652,
    x2: 363.524,
    y2: 122.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 378.68,
    y1: 103.548,
    x2: 378.671,
    y2: 105.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 378.39,
    y1: 158.163,
    x2: 378.667,
    y2: 104.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 373.824,
    y1: 122.65,
    x2: 377.435,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 373.824,
    y1: 122.65,
    x2: 377.435,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 392.591,
    y1: 103.548,
    x2: 392.582,
    y2: 105.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 392.3,
    y1: 158.163,
    x2: 392.577,
    y2: 104.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 387.734,
    y1: 122.65,
    x2: 391.345,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 387.734,
    y1: 122.65,
    x2: 391.345,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 410.279,
    y1: 183.437,
    x2: 410.279,
    y2: 127.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8D0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 434.198,
    y1: 125.583,
    x2: 434.198,
    y2: 80.3152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8D0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 463.659,
    y1: 100.336,
    x2: 463.659,
    y2: 64.1104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6393A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 404.463,
    y1: 136.353,
    x2: 404.463,
    y2: 116.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6393A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 367.163,
    y1: 59.1772,
    x2: 350.384,
    y2: 51.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#DF876F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 369.788,
    y1: 33.286,
    x2: 391.186,
    y2: 23.5545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#DF876F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 229.197,
    y1: 32.4341,
    x2: 216.619,
    y2: 45.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#DF876F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 219.386,
    y1: 18.0931,
    x2: 225.662,
    y2: 22.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#DF876F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 235.294,
    y1: 28.6348,
    x2: 241.136,
    y2: 28.6348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 359.532,
    y1: 168.049,
    x2: 322.358,
    y2: 151.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#DF876F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 289.643,
    y1: 147.469,
    x2: 303.023,
    y2: 147.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9815,
    stopColor: "#DF876F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 202.575,
    y1: 129.049,
    x2: 207.331,
    y2: 114.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 168.952,
    y1: 148.831,
    x2: 161.638,
    y2: 162.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 195.812,
    y1: 57.6568,
    x2: 171.407,
    y2: 71.8755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 220.544,
    y1: 71.5167,
    x2: 233.025,
    y2: 91.5952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 391.973,
    y1: 77.1552,
    x2: 383.612,
    y2: 57.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 364.772,
    y1: 103.55,
    x2: 364.763,
    y2: 105.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 364.478,
    y1: 158.165,
    x2: 364.756,
    y2: 104.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 359.912,
    y1: 122.652,
    x2: 363.524,
    y2: 122.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 359.912,
    y1: 122.652,
    x2: 363.524,
    y2: 122.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 378.68,
    y1: 103.548,
    x2: 378.671,
    y2: 105.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 378.39,
    y1: 158.163,
    x2: 378.667,
    y2: 104.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 373.824,
    y1: 122.65,
    x2: 377.435,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 373.824,
    y1: 122.65,
    x2: 377.435,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 392.591,
    y1: 103.548,
    x2: 392.582,
    y2: 105.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 392.3,
    y1: 158.163,
    x2: 392.577,
    y2: 104.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 387.734,
    y1: 122.65,
    x2: 391.345,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 387.734,
    y1: 122.65,
    x2: 391.345,
    y2: 122.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 410.279,
    y1: 183.437,
    x2: 410.279,
    y2: 127.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8D0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 434.198,
    y1: 125.583,
    x2: 434.198,
    y2: 80.3152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8D0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 463.659,
    y1: 100.336,
    x2: 463.659,
    y2: 64.1104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6393A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 404.463,
    y1: 136.353,
    x2: 404.463,
    y2: 116.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6393A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 347.086,
    y1: 48.8284,
    x2: 353.828,
    y2: 44.2858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#EA9B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 383.809,
    y1: 20.5618,
    x2: 386.305,
    y2: 28.7458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#EA9B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 212.67,
    y1: 52.2737,
    x2: 216.131,
    y2: 29.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#EA9B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 219.386,
    y1: 18.0931,
    x2: 225.662,
    y2: 22.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#EBA896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 235.294,
    y1: 28.6348,
    x2: 241.136,
    y2: 28.6348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 359.532,
    y1: 168.049,
    x2: 322.358,
    y2: 151.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#DF876F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 319.022,
    y1: 143.967,
    x2: 322.943,
    y2: 138.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "#EA9B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 211.627,
    y1: 19.1808,
    x2: 209.624,
    y2: 107.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 202.77,
    y1: 129.176,
    x2: 207.526,
    y2: 114.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 168.952,
    y1: 148.831,
    x2: 161.638,
    y2: 162.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 124.56,
    y1: 101.796,
    x2: 124.551,
    y2: 103.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 124.27,
    y1: 156.409,
    x2: 124.547,
    y2: 102.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 119.703,
    y1: 120.896,
    x2: 123.315,
    y2: 120.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 119.703,
    y1: 120.896,
    x2: 123.315,
    y2: 120.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 146.719,
    y1: 101.939,
    x2: 146.709,
    y2: 103.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 146.424,
    y1: 156.554,
    x2: 146.701,
    y2: 102.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 141.858,
    y1: 121.041,
    x2: 145.469,
    y2: 121.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 141.858,
    y1: 121.041,
    x2: 145.469,
    y2: 121.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 195.812,
    y1: 57.6574,
    x2: 171.407,
    y2: 71.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 220.544,
    y1: 71.5167,
    x2: 233.025,
    y2: 91.5952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDEEF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientist);
export default __webpack_public_path__ + "static/media/scientist.95091b69.svg";
export { ForwardRef as ReactComponent };